import { User } from './user.model';
import { WorkRecordMapper } from './work-record';

export class UserMapper {
  public static map(userData: any): User {
    if (userData.user) {
      userData = userData.user;
    }

    return new User(
        userData.id,
        userData.roles,
        userData.name,
        userData.surname,
        userData.phone,
        userData.email,
        userData.language,
        WorkRecordMapper.map(userData.workRecord)
      );
  }
}



// WEBPACK FOOTER //
// /dist/src/app/user/user.mapper.ts